import React from "react";
import { NavLink } from "react-router-dom";

const linkLabelClass = "subsidebar-nav-label";

const SubSideBarNavigationLink = ({ link }) => {
  const label = link?.label?.replace(" ", "_").toLowerCase();
  const isDisabled = Boolean(link?.disabled);

  if (isDisabled) {
    return (
      <li
        className={`py-2 d-flex align-items-center position-relative ${label} subscription-nav-disabled`}
      >
        <span
          className="subsidebar-nav-item text-muted"
          title={link?.disabledTitle ?? "Subscribe to unlock"}
          style={{ cursor: "not-allowed", opacity: 0.55 }}
        >
          <span className={linkLabelClass}>{link?.label}</span>
        </span>
        <span
          className="subsidebar-highlight-rail"
          aria-hidden="true"
        />
      </li>
    );
  }

  return (
    <li className={`py-2 d-flex align-items-center position-relative ${label}`}>
      <NavLink
        to={link?.path}
        className={({ isActive }) =>
          `subsidebar-nav-item ${isActive ? "text_primary" : "text-muted"}`
        }
        end
      >
        <span className={linkLabelClass}>{link?.label}</span>
      </NavLink>

      <NavLink
        to={link?.path}
        className={({ isActive }) =>
          isActive
            ? "subsidebar-highlight-rail subsidebar-highlight-rail--active"
            : "subsidebar-highlight-rail"
        }
        end
        aria-hidden="true"
        tabIndex={-1}
      />
    </li>
  );
};

export default SubSideBarNavigationLink;
